
import { defineComponent, ref, onBeforeMount, PropType } from "vue";

import EasyDrop from "@/components/EasyDrop.vue";

import { SearchAirport } from "@/types/models";

export default defineComponent({
  name: "SearchAirports",
  emits: ["updateAirports"],
  components: {
    EasyDrop
  },
  props: {
    airports: {
      type: Array as PropType<Array<SearchAirport>>,
      required: true,
    },
    pageTexts: {
      type: Object,
      required: true
    },
    isHotelApp: {
      type: Boolean
    }
  },
  setup(_props, { emit }) {
    let selectedAirport = ref();
    const displayAirports = ref(_props.airports);
    const easyDrop = ref();

    const setSelectedAirport = (airport) => {
      selectedAirport.value = airport;
      emit("updateAirports", airport);
    }

    const closeDropdown = () => {
      if (easyDrop.value)
        easyDrop.value.toggleDropdown();
    }

    onBeforeMount(() => {
      for (let airport of displayAirports.value) {
        if (airport.isSelected) {
          selectedAirport.value = airport;
          break;
        }
      }
    });

    const nextDrop = () => {
      document.getElementById('searchTravellersBtn')?.click();
    }


    return {
      easyDrop,
      closeDropdown,
      displayAirports,
      selectedAirport,
      setSelectedAirport,
      nextDrop
    }
  },
});
